module.exports = __webpack_public_path__ + "img/4-1.f5ba99e5.jpg";